import React, { useState, useRef } from "react";
import { Card, Button, Form } from "react-bootstrap";
import LeftNav from "../common/leftnav";
import { Link } from "react-router-dom";

const PaymentBilling = () => {
  const [isEditing, setIsEditing] = useState(false);
  const [cardNumber, setCardNumber] = useState(new Array(12).fill("0"));
  const [expiry, setExpiry] = useState(new Array(4).fill("0"));
  const [cvv, setCvv] = useState(new Array(3).fill(""));

  const [secondaryCardNumber, setSecondaryCardNumber] = useState(
    new Array(12).fill("")
  );
  const [secondaryExpiry, setSecondaryExpiry] = useState(new Array(4).fill(""));
  const [secondaryCvv, setSecondaryCvv] = useState(new Array(3).fill(""));
  const [method, setMethod] = useState(0);
  const [saveSecondary, setSaveSecondary] = useState(false);

  const cardRefs = useRef([]);
  const expiryRefs = useRef([]);
  const cvvRefs = useRef([]);

  const secondaryCardRefs = useRef([]);
  const secondaryExpiryRefs = useRef([]);
  const secondaryCvvRefs = useRef([]);

  const [isEditingBilling, setIsEditingBilling] = useState(false);
  const [isEditingBillingEmail, setIsEditingBillingEmail] = useState(false);
  const [billingInfo, setBillingInfo] = useState({
    street: "1112 Shamrock Ct",
    city: "Naperville",
    zip: "60540",
    state: "IL",
    country: "United States",
    emailAddress: "olivia@royalcyber.com",
  });

  const handleEditBillingClick = () => {
    setIsEditingBilling(true);
  };

  const handleBillingSave = () => {
    setIsEditingBilling(false);
  };

  const handleEditBillingEmailClick = () => {
    setIsEditingBillingEmail(true);
  };

  const handleBillingEmailSave = () => {
    setIsEditingBillingEmail(false);
  };

  const handleEditClick = (index) => {
    setMethod(index);
    setIsEditing(true);
  };
  const handleCancel = () => {
    setMethod(0);
    setIsEditing(false);
  };
  const handleSave = () => setIsEditing(false);
  const handleSaveSecondary = () => {
    setMethod(0);
    setSaveSecondary(true);
    setIsEditing(false);
  };

  const handleChange = (index, value, setter, refs) => {
    if (value.length > 1) return; 
    setter((prevState) => {
      const newState = [...prevState]; 
      newState[index] = value.replace(/\D/, ""); 
      return newState; 
    });

    if (value && index < refs.current.length - 1) {
      refs.current[index + 1].focus();
    }
  };

  const handleChangeSecondary = (index, value, setter, refs) => {
    if (value.length > 1) return; 
    setter((prevState) => {
      const newState = [...prevState];
      newState[index] = value.replace(/\D/, ""); 
      return newState; 
    });

    if (value && index < refs.current.length - 1) {
      refs.current[index + 1].focus();
    }
  };

  return (
    <div className="d-flex">
      <LeftNav />
      <div className="dashboard-content flex-grow-1 p-4 bg-light">
        <div className="mb-4">
          <h2 className="fs-five-title fw-bold ms-2">Billing</h2>
          <p className="text-muted ms-2">
            Manage your payment methods and billing details in one place.
          </p>
          <Card className="shadow-sm border-0 p-4 rounded-4 mb-4">
            <Link to=".." relative="path">
              <Button
                variant="link"
                className="purple-color text-decoration-none fw-bold btn btn-link"
                style={{ paddingLeft: "0px" }}
              >
                <img
                  src="/assets/arrow-left-sm.svg"
                  alt="Arrow Left"
                  className="img-fluid me-2"
                />
                Go back
              </Button>
            </Link>
            <h5 className="fw-bold m-1">
              <img
                src="/assets/payment-receipt.svg"
                alt="card"
                className="img-fluid"
              />{" "}
              Payment & Billing Detail
            </h5>
            <p className="m-1 text-muted ms-2">
              Manage your payment methods and billing details in one place.
            </p>
            <hr className="border-dark-subtle" />

            <Card className="p-3 mb-3 mt-1 bg-white">
              <div className="justify-content-between align-items-center">
                <div>
                  <div className="d-flex justify-content-between align-items-center">
                    <strong>
                      {method === 0 ? "Primary" : "Secondary"} Payment Method:
                    </strong>
                    {!isEditing && (
                      <Button
                        variant="link"
                        className="purple-color text-decoration-none fw-bold"
                        onClick={() => handleEditClick(0)}
                      >
                        <img
                          src="/assets/edit-1.svg"
                          alt="edit"
                          className="img-fluid"
                        />{" "}
                        Edit
                      </Button>
                    )}
                  </div>

                  {!isEditing ? (
                    <Card
                      className="p-4 mt-2 shadow-sm"
                      style={{ backgroundColor: "#F4F3FF" }}
                    >
                      <div className="d-flex align-items-center">
                        <img
                          src="/assets/visa-sign.svg"
                          alt="visa"
                          className="m-2"
                        />
                        <div>
                          Visa ending in {cardNumber.slice(-4).join("")}
                          <p className="mb-0 text-muted">
                            Expiry {expiry.join("")}
                          </p>
                        </div>
                      </div>
                    </Card>
                  ) : (
                    <Card
                      className="p-4 mt-2 shadow-sm"
                      style={{ backgroundColor: "#F4F3FF" }}
                    >
                      <Form>
                        <Form.Group className="mb-3">
                          <Form.Label>Card Number</Form.Label>
                          <div className="d-flex">
                            {method === 0
                              ? cardNumber.map((digit, index) => (
                                  <React.Fragment key={index}>
                                    <Form.Control
                                      type="text"
                                      value={digit}
                                      className="text-center me-1 fw-bold"
                                      style={{
                                        width: "40px",
                                        textAlign: "center",
                                      }}
                                      maxLength="1"
                                      ref={(el) =>
                                        (cardRefs.current[index] = el)
                                      }
                                      onChange={(e) =>
                                        handleChange(
                                          index,
                                          e.target.value,
                                          setCardNumber,
                                          cardRefs
                                        )
                                      }
                                    />
                                    {(index + 1) % 4 === 0 &&
                                      index !== cardNumber.length - 1 && (
                                        <span className="mx-3 mt-2 fw-bold">
                                          -
                                        </span>
                                      )}
                                  </React.Fragment>
                                ))
                              : secondaryCardNumber.map((digit, index) => (
                                  <React.Fragment key={index}>
                                    <Form.Control
                                      type="text"
                                      value={digit}
                                      className="text-center me-1 fw-bold"
                                      style={{
                                        width: "40px",
                                        textAlign: "center",
                                      }}
                                      maxLength="1"
                                      ref={(el) =>
                                        (secondaryCardRefs.current[index] = el)
                                      }
                                      onChange={(e) =>
                                        handleChangeSecondary(
                                          index,
                                          e.target.value,
                                          setSecondaryCardNumber,
                                          secondaryCardRefs
                                        )
                                      }
                                    />
                                    {(index + 1) % 4 === 0 &&
                                      index !==
                                        secondaryCardNumber.length - 1 && (
                                        <span className="mx-3 mt-2 fw-bold">
                                          -
                                        </span>
                                      )}
                                  </React.Fragment>
                                ))}
                          </div>
                        </Form.Group>

                        <div className="d-flex">
                          <Form.Group className="me-3">
                            <Form.Label>Expiry Date</Form.Label>
                            <div className="d-flex">
                              {method === 0
                                ? expiry.map((digit, index) => (
                                    <React.Fragment key={index}>
                                      <Form.Control
                                        key={index}
                                        type="text"
                                        value={digit}
                                        className="text-center me-1"
                                        style={{
                                          width: "40px",
                                          textAlign: "center",
                                        }}
                                        maxLength="1"
                                        ref={(el) =>
                                          (expiryRefs.current[index] = el)
                                        }
                                        onChange={(e) =>
                                          handleChange(
                                            index,
                                            e.target.value,
                                            setExpiry,
                                            expiryRefs
                                          )
                                        }
                                      />
                                      {(index + 1) % 2 === 0 &&
                                        index !== expiry.length - 1 && (
                                          <span className="mx-2 mt-2 fw-bold">
                                            /
                                          </span>
                                        )}
                                    </React.Fragment>
                                  ))
                                : secondaryExpiry.map((digit, index) => (
                                    <React.Fragment key={index}>
                                      <Form.Control
                                        key={index}
                                        type="text"
                                        value={digit}
                                        className="text-center me-1"
                                        style={{
                                          width: "40px",
                                          textAlign: "center",
                                        }}
                                        maxLength="1"
                                        ref={(el) =>
                                          (secondaryExpiryRefs.current[index] =
                                            el)
                                        }
                                        onChange={(e) =>
                                          handleChangeSecondary(
                                            index,
                                            e.target.value,
                                            setSecondaryExpiry,
                                            secondaryExpiryRefs
                                          )
                                        }
                                      />
                                      {(index + 1) % 2 === 0 &&
                                        index !==
                                          secondaryExpiry.length - 1 && (
                                          <span className="mx-2 mt-2 fw-bold">
                                            /
                                          </span>
                                        )}
                                    </React.Fragment>
                                  ))}
                            </div>
                          </Form.Group>

                          <Form.Group className="mx-5">
                            <Form.Label>CVV</Form.Label>
                            <div className="d-flex">
                              {method === 0
                                ? cvv.map((digit, index) => (
                                    <Form.Control
                                      key={index}
                                      type="text"
                                      value={digit}
                                      className="text-center me-1"
                                      style={{
                                        width: "40px",
                                        textAlign: "center",
                                      }}
                                      maxLength="1"
                                      ref={(el) =>
                                        (cvvRefs.current[index] = el)
                                      }
                                      onChange={(e) =>
                                        handleChange(
                                          index,
                                          e.target.value,
                                          setCvv,
                                          cvvRefs
                                        )
                                      }
                                    />
                                  ))
                                : secondaryCvv.map((digit, index) => (
                                    <Form.Control
                                      key={index}
                                      type="text"
                                      value={digit}
                                      className="text-center me-1"
                                      style={{
                                        width: "40px",
                                        textAlign: "center",
                                      }}
                                      maxLength="1"
                                      ref={(el) =>
                                        (secondaryCvvRefs.current[index] = el)
                                      }
                                      onChange={(e) =>
                                        handleChangeSecondary(
                                          index,
                                          e.target.value,
                                          setSecondaryCvv,
                                          secondaryCvvRefs
                                        )
                                      }
                                    />
                                  ))}
                            </div>
                          </Form.Group>
                        </div>

                        <div className="d-flex justify-content-end mt-3">
                          <Button
                            variant="light"
                            className="me-2"
                            onClick={handleCancel}
                          >
                            Cancel
                          </Button>
                          <Button
                            variant="primary"
                            onClick={
                              method === 0 ? handleSave : handleSaveSecondary
                            }
                          >
                            Save changes
                          </Button>
                        </div>
                      </Form>
                    </Card>
                  )}
                </div>
              </div>
              {!isEditing && !saveSecondary && (
                <div className="pt-3">
                  <Button
                    variant="link"
                    className="purple-color text-decoration-none fw-bold"
                    onClick={() => handleEditClick(1)}
                  >
                    Add a secondary payment method
                  </Button>
                  <p className="p-2 text-muted small">
                    Updating your payment method will automatically retry any
                    failed payments. Adding a secondary payment method can help
                    avoid unnecessary service interruptions if the primary
                    method fails.
                  </p>
                </div>
              )}

              {!isEditing && saveSecondary && (
                <div className="justify-content-between align-items-center mt-4">
                  <div>
                    <div className="d-flex justify-content-between align-items-center">
                      <strong>Secondary Payment Method:</strong>
                      {!isEditing && (
                        <Button
                          variant="link"
                          className="purple-color text-decoration-none fw-bold"
                          onClick={() => handleEditClick(1)}
                        >
                          <img
                            src="/assets/edit-1.svg"
                            alt="edit"
                            className="img-fluid"
                          />{" "}
                          Edit
                        </Button>
                      )}
                    </div>
                    <Card
                      className="p-4 mt-2 shadow-sm"
                      style={{ backgroundColor: "#F4F3FF" }}
                    >
                      <div className="d-flex align-items-center">
                        <img
                          src="/assets/visa-sign.svg"
                          alt="visa"
                          className="m-2"
                        />
                        <div>
                          Visa ending in{" "}
                          {secondaryCardNumber.slice(-4).join("")}
                          <p className="mb-0 text-muted">
                            Expiry {secondaryExpiry.join("")}
                          </p>
                        </div>
                      </div>
                    </Card>
                  </div>
                </div>
              )}
            </Card>
            <Card className="p-4 mb-3 bg-white">
              {!isEditingBilling ? (
                <div className="d-flex justify-content-between align-items-center">
                  <div>
                    <strong className="d-block mb-2">Billing Address</strong>
                    <img
                      src="/assets/map-pin-gray.svg"
                      alt="map pin"
                      className="img-fluid"
                    />
                    <span className="m-1">
                      {billingInfo.street}, {billingInfo.city},{" "}
                      {billingInfo.state}, {billingInfo.zip}{" "}
                      {billingInfo.country}
                    </span>
                  </div>
                  <Button
                    variant="link"
                    className="purple-color text-decoration-none fw-bold"
                    onClick={handleEditBillingClick}
                  >
                    <img
                      src="/assets/edit-1.svg"
                      alt="edit"
                      className="img-fluid"
                    />{" "}
                    Edit
                  </Button>
                </div>
              ) : (
                <div>
                  <strong className="d-block mb-2">Billing Address</strong>
                  <Form>
                    <Form.Group className="mb-2">
                      <Form.Label>Street Address</Form.Label>
                      <Form.Control
                        type="text"
                        value={billingInfo.street}
                        onChange={(e) =>
                          setBillingInfo({
                            ...billingInfo,
                            street: e.target.value,
                          })
                        }
                      />
                    </Form.Group>

                    <div className="d-flex">
                      <Form.Group className="me-2 w-50">
                        <Form.Label>City</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Enter City"
                          value={billingInfo.city}
                          onChange={(e) =>
                            setBillingInfo({
                              ...billingInfo,
                              city: e.target.value,
                            })
                          }
                        />
                      </Form.Group>

                      <Form.Group className="w-50">
                        <Form.Label>Zip Code</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Enter Zip Code"
                          value={billingInfo.zip}
                          onChange={(e) =>
                            setBillingInfo({
                              ...billingInfo,
                              zip: e.target.value,
                            })
                          }
                        />
                      </Form.Group>
                    </div>

                    <div className="d-flex mt-2">
                      <Form.Group className="me-2 w-50">
                        <Form.Label>State/Province</Form.Label>
                        <Form.Control
                          type="text"
                          value={billingInfo.state}
                          onChange={(e) =>
                            setBillingInfo({
                              ...billingInfo,
                              state: e.target.value,
                            })
                          }
                        />
                      </Form.Group>

                      <Form.Group className="w-50">
                        <Form.Label>Country</Form.Label>
                        <Form.Control
                          type="text"
                          value={billingInfo.country}
                          onChange={(e) =>
                            setBillingInfo({
                              ...billingInfo,
                              country: e.target.value,
                            })
                          }
                        />
                      </Form.Group>
                    </div>

                    <div className="d-flex justify-content-end mt-3">
                      <Button
                        variant="light"
                        className="me-2"
                        onClick={() => setIsEditingBilling(false)}
                      >
                        Cancel
                      </Button>
                      <Button variant="primary" onClick={handleBillingSave}>
                        Save changes
                      </Button>
                    </div>
                  </Form>
                </div>
              )}
            </Card>
            <Card className="p-4 mb-3 bg-white">
              {!isEditingBillingEmail ? (
                <div className="d-flex justify-content-between align-items-center">
                  <div>
                    <strong className="d-block mb-2">
                      Billing Email Address
                    </strong>
                    <img
                      src="/assets/map-pin-gray.svg"
                      alt="map pin"
                      className="img-fluid"
                    />
                    <span className="m-1">{billingInfo.emailAddress}</span>
                  </div>
                  <Button
                    variant="link"
                    className="purple-color text-decoration-none fw-bold"
                    onClick={handleEditBillingEmailClick}
                  >
                    <img
                      src="/assets/edit-1.svg"
                      alt="edit"
                      className="img-fluid"
                    />{" "}
                    Edit
                  </Button>
                </div>
              ) : (
                <div>
                  <strong className="d-block mb-2">
                    Billing Email Address
                  </strong>
                  <Form>
                    <Form.Group className="mb-2">
                      <Form.Control
                        type="text"
                        value={billingInfo.emailAddress}
                        onChange={(e) =>
                          setBillingInfo({
                            ...billingInfo,
                            emailAddress: e.target.value,
                          })
                        }
                      />
                    </Form.Group>
                    <div className="d-flex justify-content-end mt-3">
                      <Button
                        variant="light"
                        className="me-2"
                        onClick={() => setIsEditingBillingEmail(false)}
                      >
                        Cancel
                      </Button>
                      <Button
                        variant="primary"
                        onClick={handleBillingEmailSave}
                      >
                        Save changes
                      </Button>
                    </div>
                  </Form>
                </div>
              )}
            </Card>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default PaymentBilling;
